import * as React from 'react';
import { RssItem, Rss } from 'models';
import ListItem from './ListItem';
import Loading from 'shared/Loading';

interface Props {
  className: string;
  title: string;
  url: string;
}

interface StringReplacer {
  regex: RegExp;
  replacement: string;
}

function List(props: Props) {
  const [articles, setArticles] = React.useState<RssItem[]>([]);
  React.useEffect(function () {
    const urlParts = [
      'https://api.rss2json.com/v1/api.json?',
      `rss_url=${encodeURIComponent(props.url)}`,
      `api_key=nlzxnnxh5caeaemhefqniyymygaowzk3002byhfh`
    ];
    fetch(urlParts.join('&'))
      .then(function (response) {
        return response.json();
      })
      .then(function (json: Rss) {
        const items = json.items.map(function (item) {
          const stringReplacers: StringReplacer[] = [
            // replace images to prevent them loading even when hidden by CSS
            { regex: /<img.+?[\/]?>/gi, replacement: '' },
            // add target="_blank" to links
            { regex: /(<a.+?)>/gi, replacement: '$1 target="_blank">' },
          ];
          const description = stringReplacers.reduce(function (memo, stringReplacer) {
            return memo.replace(stringReplacer.regex, stringReplacer.replacement);
          }, item.description);
          return {
            ...item,
            description,
          };
        });
        setArticles(items);
      });
  }, []);

  return (
    <section className={`article-list ${props.className}`}>
      <h2>{props.title}</h2>
      {articles.length === 0 && <Loading />}
      {articles.map((article) => <ListItem key={article.title} article={article} />)}
    </section>
  );
}
export default List;
